import React from "react";
import { PeekBox, PeekStack } from "@piiqtechnologies/ui-components";
import { useBillingEnabled } from "@hooks";
import { useOptionalPlansBillingContext } from "@stores/PlansBillingContext";
const PlansBilling = React.lazy(() => import("@pages/plans-billing"));
const AccountSettings = React.lazy(() => import("@pages/account-settings"));
export const DashboardLayout = ({ banner, sidebar, children, contentRef, pageHeader, }) => {
    const billingEnabled = useBillingEnabled();
    const plansBilling = useOptionalPlansBillingContext();
    const showPlansBilling = billingEnabled && Boolean(plansBilling === null || plansBilling === void 0 ? void 0 : plansBilling.isPlansBillingOpen);
    const showAccountSettings = Boolean(plansBilling === null || plansBilling === void 0 ? void 0 : plansBilling.isAccountSettingsOpen);
    return (React.createElement(PeekStack, { width: "100%", height: "100vh", direction: "column", justifyContent: "space-between" },
        React.createElement(PeekStack, { direction: "row", sx: { width: "100%", flex: 1, minHeight: 0 } },
            sidebar,
            React.createElement(PeekBox, { ref: contentRef, sx: {
                    p: 2,
                    flex: 1,
                    overflowY: "auto",
                    backgroundColor: "grey.50",
                    display: "flex",
                    flexDirection: "column",
                } }, showAccountSettings ? (React.createElement(AccountSettings, null)) : showPlansBilling ? (React.createElement(PlansBilling, null)) : (React.createElement(PeekStack, { gap: 3, sx: { flex: 1, minHeight: 0 } }, pageHeader ? (React.createElement(PeekStack, { gap: 2 },
                banner && banner,
                pageHeader,
                children)) : (React.createElement(PeekStack, { gap: 2, sx: { flex: 1, minHeight: 0 } },
                banner && banner,
                children))))))));
};
export default DashboardLayout;
